// extracted by mini-css-extract-plugin
export default {"section":"Section_section__v7wdF","form":"Section_form__rBy7T"};